var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column flex-shrink-0 vh-100 overflow-hidden"},[_c('section-login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }